import React from 'react';
import PropTypes from 'prop-types';
import InputWithLabel from '../base/InputWithLabel/InputWithLabel';
import Title from '../base/Title/Title';
import textTranslates from './translate.json';
const CustomerForm = (props) => {
    return(
        <div
            className= "col-xs-12"
            id= "customer-details">
            <Title
                id="customerFormTitle"
                title={textTranslates.customerFormTitle}/>
            <div className="col-xs-12"> 
                <InputWithLabel
                    className="col-xs-6"
                    id="customerNameInput"
                    label={textTranslates.customerNameInputLabel}
                    onChange={props.onCustomerNameChanged}
                    placeholder={textTranslates.customerNameInputPlaceholder}
                    type="text"
                    value={props.customer.name} />
                <InputWithLabel
                    className="col-xs-6"
                    id="customerSurnameInput"
                    label={textTranslates.customerSurnameInputLabel}
                    onChange={props.onCustomerSurnameChanged}
                    placeholder={textTranslates.customerSurnameInputPlaceholder}
                    type="text"
                    value={props.customer.surname} />
                <InputWithLabel 
                    className="col-xs-12 col-sm-4"
                    id="customerEmailInput"
                    label={textTranslates.customerEmailInputLabel}
                    onChange={props.onCustomerEmailChanged}
                    placeholder={textTranslates.customerEmailInputPlaceholder}
                    type="email"
                    value={props.customer.email} />
                {/* <InputWithLabel
                    className="col-xs-12 col-sm-4"
                    id="customerPhoneCodeInput"
                    label={textTranslates.customerPhoneCodeInputLabel}
                    onChange={props.onCustomerPhoneCodeChanged}
                    placeholder={textTranslates.customerPhoneCodeInputPlaceholder}
                    type="text"
                    value={props.customer.phoneCode} /> */}
                <InputWithLabel
                    className="col-xs-12 col-sm-4"
                    id="customerPhoneInput"
                    label={textTranslates.customerPhoneInputLabel}
                    onChange={props.onCustomerPhoneChanged}
                    placeholder={textTranslates.customerPhoneInputPlaceholder}
                    type="text"
                    value={props.customer.phone} />
                <InputWithLabel
                    className="col-xs-12 col-sm-8"
                    id="customerStreetInput"
                    label={textTranslates.customerStreetInputLabel}
                    onChange={props.onCustomerStreetChanged}
                    placeholder={textTranslates.customerStreetInputPlaceholder}
                    type="text"
                    value={props.customer.street} />
                <InputWithLabel
                    className="col-xs-12 col-sm-2"
                    id="customerBuildingNumberInput"
                    label={textTranslates.customerBuildingNumberInputLabel}
                    onChange={props.onCustomerBuildingNumberChanged}
                    placeholder={textTranslates.customerBuildingNumberInputPlaceholder}
                    type="text"
                    value={props.customer.buildingNumber} />
                <InputWithLabel
                    className="col-xs-12 col-sm-2"
                    id="customerFlatNumberInput"
                    label={textTranslates.customerFlatNumberInputLabel}
                    onChange={props.onCustomerFlatNumberChanged}
                    placeholder={textTranslates.customerFlatNumberInputPlaceholder}
                    type="text"
                    value={props.customer.flatNumber} />
                <InputWithLabel
                    className="col-xs-12 col-sm-8"
                    id="customerCityInput"
                    label={textTranslates.customerCityInputLabel}
                    onChange={props.onCustomerCityChanged}
                    placeholder={textTranslates.customerCityInputPlaceholder}
                    type="text"
                    value={props.customer.city} />
                <InputWithLabel
                    className="col-xs-12 col-sm-4"
                    id="customerPostalCode"
                    label={textTranslates.customerPostalCodeLabel}
                    onChange={props.onCustomerPostalCodeChanged}
                    placeholder={textTranslates.customerPostalCodePlaceholder}
                    type="text"
                    value={props.customer.postalCode} />
            </div>
        </div>
    );
};

CustomerForm.propTypes = {
    customer: PropTypes.shape({
        buildingNumber: PropTypes.string,
        city: PropTypes.string,
        email: PropTypes.string,
        flatNumber: PropTypes.string,
        name: PropTypes.string,
        phone: PropTypes.string,
        postalCode: PropTypes.string,
        street: PropTypes.string,
        type: PropTypes.shape({
            value: PropTypes.string
        }),
        companyTax: PropTypes.string
    }),
    onCustomerBuildingNumberChanged: PropTypes.func,
    onCompanyTaxChanged: PropTypes.func,
    onCustomerCityChanged: PropTypes.func,
    onCustomerEmailChanged: PropTypes.func,
    onCustomerFlatNumberChanged: PropTypes.func,
    onCustomerNameChanged: PropTypes.func,
    onCustomerPhoneChanged: PropTypes.func,
    onCustomerPostalCodeChanged: PropTypes.func,
    onCustomerStreetChanged: PropTypes.func,
};

export default CustomerForm;


// WEBPACK FOOTER //
// ./src/components/Customer/CustomerForm.js